import { render, staticRenderFns } from "./TJ-Snackbar.vue?vue&type=template&id=c5ee6350&scoped=true&"
import script from "./TJ-Snackbar.vue?vue&type=script&lang=js&"
export * from "./TJ-Snackbar.vue?vue&type=script&lang=js&"
import style0 from "./TJ-Snackbar.vue?vue&type=style&index=0&id=c5ee6350&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ee6350",
  null
  
)

export default component.exports